module.exports = {
    "Address changed": {
        "es_ES": "Dirección cambiada",
        "fr_FR": "Adresse modifiée"
    },
    "Organization has been removed from group.": {
        "es_ES": "La organización ha sido eliminada del grupo.",
        "fr_FR": "L'organisation a été supprimée du groupe."
    },
    "Cancel": {
        "es_ES": "Cancelar",
        "fr_FR": "Annuler"
    },
    "Do you want to delete selected user? This cannot be undone.": {
        "es_ES": "¿Quieres eliminar el usuario seleccionado? Esto no se puede deshacer.",
        "fr_FR": "Voulez-vous supprimer l'utilisateur sélectionné? Ça ne peut pas être annulé."
    },
    "Delete user": {
        "es_ES": "Borrar usuario",
        "fr_FR": "Supprimer l'utilisateur"
    },
    "Delete": {
        "es_ES": "Borrar",
        "fr_FR": "Supprimer"
    },
    "Edit user": {
        "es_ES": "Editar usuario",
        "fr_FR": "Modifier l'utilisateur"
    },
    "Send Invite": {
        "es_ES": "Enviar invitación",
        "fr_FR": "Envoyer l'invitation"
    },
    "Reprint Renewal Updated.": {
        "es_ES": "Reimpresión de la renovación actualizada.",
        "fr_FR": "Réimpression du renouvellement mis à jour."
    },
    "Hymnals have been successfully updated": {
        "es_ES": "Los himnales se han actualizado con éxito",
        "fr_FR": "Les hymnes ont été mis à jour avec succès"
    },
    "Services have been successfully updated": {
        "es_ES": "Los servicios se han actualizado correctamente",
        "fr_FR": "Nombre de cultes ont été mis à jour avec succès"
    },
    "Account has been successfully updated": {
        "es_ES": "La cuenta se ha actualizado con éxito",
        "fr_FR": "Le compte a été mis à jour avec succès"
    },
    "Organization Profile has been successfully updated": {
        "es_ES": "El perfil de la organización se ha actualizado con éxito",
        "fr_FR": "Le profil de l'organisation a été mis à jour avec succès"
    },
    "Form has errors": {
        "es_ES": "El formulario tiene errores",
        "fr_FR": "Le formulaire a des erreurs"
    },
    "Are you sure this organization should be removed from group?": {
        "es_ES": "¿Estás seguro de que esta organización debe ser eliminada del grupo?",
        "fr_FR": "Êtes-vous sûr que cette organisation devrait être retirée du groupe?"
    },
    "Send invitation": {
        "es_ES": "Enviar invitacion",
        "fr_FR": "Envoyer une invitation"
    },
    "Remove from group": {
        "es_ES": "Sacar del grupo",
        "fr_FR": "Retirer du groupe"
    },
    "Organization has been saved.": {
        "es_ES": "La organización ha sido guardada.",
        "fr_FR": "L'organisation a été sauvée."
    },
    "Print Snippet copied to clipboard": {
        "es_ES": "Fragmento de impresión copiado al portapapeles",
        "fr_FR": "Extrait d’impression copié dans le presse-papiers"
    },
    "Used in Practice": {
        "es_ES": "Usado en la práctica",
        "fr_FR": "Utilisé pour la pratique"
    },
    "Used in Service": {
        "es_ES": "Usado en el servicio",
        "fr_FR": "Utilisé pendant un service"
    },
    "You are reporting {count} title(s):": {
        "es_ES": "Está reportando {count} título(s):",
        "fr_FR": "Vous signalez {count} title (s):"
    },
    "Report titles": {
        "es_ES": "Reportar títulos",
        "fr_FR": "Rapporter les titres"
    },
    "You are editing report for:": {
        "es_ES": "Estás editando el informe por:",
        "fr_FR": "Vous modifiez un rapport pour:"
    },
    "You are reporting title": {
        "es_ES": "Está reportando título",
        "fr_FR": "Vous signalez le titre"
    },
    "Songs has been removed.": {
        "es_ES": "Las canciones han sido eliminadas.",
        "fr_FR": "Les chansons ont été supprimées."
    },
    "Are you sure you want to delete all reported songs from this week?": {
        "es_ES": "¿Estás seguro de que quieres eliminar todas las canciones reportadas de esta semana?",
        "fr_FR": "Êtes-vous sûr de vouloir supprimer toutes les chansons signalées de cette semaine?"
    },
    "No pending tracks to display": {
        "es_ES": "No hay pistas pendientes para mostrar",
        "fr_FR": "Pas de pistes en attente à afficher"
    },
    "User has been deleted.": {
        "es_ES": "El usuario ha sido eliminado.",
        "fr_FR": "L'utilisateur a été supprimé."
    },
    "Do you want to send invitation to selected user?": {
        "es_ES": "¿Quieres enviar invitación al usuario seleccionado?",
        "fr_FR": "Voulez-vous envoyer une invitation à l'utilisateur sélectionné?"
    },
    "Select title to report": {
        "es_ES": "Seleccione el título para informar",
        "fr_FR": "Sélectionnez le titre à signaler"
    },
    "Decline": {
        "es_ES": "Rechazar",
        "fr_FR": "Refuser"
    },
    "Add User": {
        "es_ES": "Añadir Usuario",
        "fr_FR": "Ajouter l'utilisateur"
    },
    "User has been deleted": {
        "es_ES": "El usuario ha sido eliminado",
        "fr_FR": "L'utilisateur a été supprimé"
    },
    "Select User": {
        "es_ES": "Seleccionar usuario",
        "fr_FR": "Sélectionner l'utilisateur"
    },
    "Edit User": {
        "es_ES": "Editar usuario",
        "fr_FR": "Modifier l'utilisateur"
    },
    "User has been added": {
        "es_ES": "Se ha agregado el usuario",
        "fr_FR": "L'utilisateur a été ajouté"
    },
    "User has been updated": {
        "es_ES": "El usuario ha sido actualizado",
        "fr_FR": "L'utilisateur a été mis à jour"
    },
    "contain  at least one number [0 - 9]": {
        "es_ES": "Que contenga al menos un número [0 - 9]",
        "fr_FR": "Doit contenir au moins un chiffre [0 - 9]"
    },
    "contain  at least one uppercase letter [A - Z]": {
        "es_ES": "Que contenga al menos una letra mayúscula [A - Z]",
        "fr_FR": "Doit contenir au moins une lettre majuscule [A - Z]"
    },
    "contain  at least one lowercase letter [a - z]": {
        "es_ES": "Que contenga al menos una letra minúscula [a - z]",
        "fr_FR": "Doit contenir au moins une lettre minuscule [a - z]"
    },
    "be at least 8 characters": {
        "es_ES": "Debe tener al menos 8 caracteres",
        "fr_FR": "Doit contenir au moins huit caractères"
    },
    "Cookie Policy": {
        "es_ES": "Política de cookies",
        "fr_FR": "Politique en matière de témoins"
    },
    "Learn more": {
        "es_ES": "Más información",
        "fr_FR": "En savoir plus"
    },
    "Allow cookies": {
        "es_ES": "Permitir cookies",
        "fr_FR": "Autoriser les témoins"
    },
    "Send Invitation": {
        "es_ES": "Enviar invitacion",
        "fr_FR": "Envoyer une invitation"
    },
    "Got it!": {
        "es_ES": "¡Entiendo!",
        "fr_FR": "Compris !"
    },
    "This website uses cookies to ensure you get the best experience on our website.": {
        "es_ES": "Este sitio web utiliza cookies para asegurarse de que obtenga la mejor experiencia en nuestro sitio web.",
        "fr_FR": "Ce site web utilise des témoins pour vous garantir la meilleure expérience sur notre site."
    },
    "Cookies used on the website!": {
        "es_ES": "¡Cookies utilizadas en el sitio web!",
        "fr_FR": "Cookies utilisés sur le site !"
    },
    "List has been successfully added": {
        "es_ES": "La lista ha sido agregada con éxito",
        "fr_FR": "La liste a été ajoutée avec succès"
    },
    "List has been renamed": {
        "es_ES": "Lista ha sido renombrada",
        "fr_FR": "La liste a été renommée"
    },
    "Please, select a list to edit.": {
        "es_ES": "Por favor, seleccione una lista para editar.",
        "fr_FR": "Veuillez sélectionner une liste à modifier."
    },
    "Select a list to edit": {
        "es_ES": "Seleccione una lista para editar",
        "fr_FR": "Sélectionnez une liste pour modifier"
    },
    "Welcome packets has been sent": {
        "es_ES": "Los paquetes de bienvenida han sido enviados",
        "fr_FR": "Les paquets de bienvenue ont été envoyés"
    },
    "Send Welcome Packets": {
        "es_ES": "Enviar paquetes de bienvenida",
        "fr_FR": "Envoyer des paquets de bienvenue"
    },
    "Are you sure you want to send Welcome Packets to all users on file?": {
        "es_ES": "¿Está seguro de que desea enviar paquetes de bienvenida a todos los usuarios registrados?",
        "fr_FR": "Êtes-vous sûr d'envoyer des paquets de bienvenue à tous les utilisateurs dans le dossier?"
    },
    "Are you sure you want to send Welcome Packets to all suborganizations and users on file?": {
        "es_ES": "¿Está seguro de que desea enviar paquetes de bienvenida a todas las suborganizaciones y usuarios registrados?",
        "fr_FR": "Êtes-vous sûr d'envoyer des paquets de bienvenue à toutes les sous-organisations et utilisateurs dans le fichier?"
    },
    "Invitation has been sent": {
        "es_ES": "Se ha enviado una invitación",
        "fr_FR": "L'invitation a été envoyée"
    },
    "List has been saved successfully.": {
        "es_ES": "La lista se ha guardado con éxito.",
        "fr_FR": "La liste a été enregistrée avec succès."
    },
    "Delete All Reported Songs": {
        "es_ES": "Eliminar todas las canciones reportadas",
        "fr_FR": "Supprimer toutes les chansons signalées"
    },
    "Select a list to report from": {
        "es_ES": "Seleccione una lista para informar de",
        "fr_FR": "Sélectionnez une liste à signaler"
    },
    "Close Downloadable Files": {
        "es_ES": "Cerrar archivos descargables",
        "fr_FR": "Fermer les fichiers téléchargeables"
    },
    "Are you sure this report should be removed?": {
        "es_ES": "¿Está seguro de que este informe debe eliminarse?",
        "fr_FR": "Êtes-vous sûr que ce rapport devrait être supprimé?"
    },
    "Remove report": {
        "es_ES": "Eliminar informe",
        "fr_FR": "Supprimer le rapport"
    },
    "Select Copyright": {
        "es_ES": "Seleccionar derechos de autor",
        "fr_FR": "Sélectionner le droit d'auteur"
    },
    "Choose One": {
        "es_ES": "Elige uno",
        "fr_FR": "Choisissez-en un"
    },
    "Oops! It looks like that file is currently unavailable. Don't worry, the Member Publisher has been notified and a fix is on the way.": {
        "es_ES": "¡Ups! Parece que ese archivo no está disponible actualmente. No se preocupe, el editor miembro ha sido notificado y una solución está en camino.",
        "fr_FR": "Oops! Il semble que ce fichier ne soit actuellement pas disponible. Ne vous inquiétez pas, l'éditeur membre a été informé et un correctif est en route."
    },
    "matching results for": {
        "es_ES": "resultados coincidentes para",
        "fr_FR": "résultats de correspondance pour"
    },
    "Hymnals \/ Resources": {
        "es_ES": "Himnarios \/ recursos",
        "fr_FR": "Hymnes \/ ressources"
    },
    "Login": {
        "es_ES": "Acceso",
        "fr_FR": "Se connecter"
    },
    "Purchase License": {
        "es_ES": "Licencia de compra",
        "fr_FR": "Licence d'achat"
    },
    "PDF and TIFF files are available to license holders to make creating worship aids easy!": {
        "es_ES": "¡Los archivos PDF y TIFF están disponibles para los titulares de licencias para facilitar la creación de ayudas de adoración!",
        "fr_FR": "Des fichiers PDF et TIFF sont disponibles pour les titulaires de licence pour faciliter la création d'aides à l'adoration!"
    },
    "of {numOfPages}": {
        "es_ES": "de {numOfPages}",
        "fr_FR": "de {numofPages}"
    },
    "SKU Copied to clipboard": {
        "es_ES": "Sku copiado al portapapeles",
        "fr_FR": "UGS copié dans le presse-papiers"
    },
    "View more versions": {
        "es_ES": "Ver más versiones",
        "fr_FR": "Afficher plus de versions"
    },
    "Select List": {
        "es_ES": "Seleccionar lista",
        "fr_FR": "Sélectionner la liste"
    },
    "Success": {
        "es_ES": "Éxito",
        "fr_FR": "Succès"
    },
    "Select Type": {
        "es_ES": "Seleccione tipo",
        "fr_FR": "Sélectionner le genre"
    },
    "Select Timezone": {
        "es_ES": "Selecciona la zona horaria",
        "fr_FR": "Sélectionnez le fuseau horaire"
    },
    "Select Country": {
        "es_ES": "Seleccionar país",
        "fr_FR": "Choisissez le pays"
    },
    "Select Denomination": {
        "es_ES": "Denominación",
        "fr_FR": "Sélectionner la dénomination"
    },
    "Select State": {
        "es_ES": "Seleccione estado",
        "fr_FR": "Sélectionnez l'état"
    },
    "show": {
        "es_ES": "mostrar",
        "fr_FR": "montrer"
    },
    "hide": {
        "es_ES": "ocultar",
        "fr_FR": "cacher"
    },
    "Code is wrong or expired": {
        "es_ES": "El código está mal o caducado",
        "fr_FR": "Le code est mauvais ou expiré"
    },
    "Scroll to top": {
        "es_ES": "Volver al inicio de la página",
        "fr_FR": "Faire défiler vers le haut"
    },
    "Thank you for paying Invoice #{invoice}. Receipt has been emailed to the account owner and billing contacts.": {
        "es_ES": "Gracias por pagar la factura #{invoice}. El recibo ha sido enviado por correo electrónico al propietario de la cuenta y contactos de facturación.",
        "fr_FR": "Merci d'avoir payé la facture # {facture}. Le reçu a été envoyé par courriel au propriétaire du compte et aux contacts de facturation."
    },
    "Select Account Type": {
        "es_ES": "Seleccione Tipo de cuenta",
        "fr_FR": "Sélectionner le type de compte"
    },
    "Select Year": {
        "es_ES": "Seleccionar Año",
        "fr_FR": "Année"
    },
    "Select Month": {
        "es_ES": "Seleccione mes",
        "fr_FR": "Mois"
    },
    "Yes": {
        "es_ES": "Sí",
        "fr_FR": "Oui"
    },
    "Report succesfully updated.": {
        "es_ES": "Informe actualizado con éxito.",
        "fr_FR": "Signaler avec succès mis à jour."
    },
    "Report has been removed.": {
        "es_ES": "Se ha eliminado el informe.",
        "fr_FR": "Le rapport a été supprimé."
    },
    "Report has been updated.": {
        "es_ES": "El informe ha sido actualizado.",
        "fr_FR": "Le rapport a été mis à jour."
    },
    "results": {
        "es_ES": "resultados",
        "fr_FR": "résultats"
    },
    "You will not be notified about this week anymore.": {
        "es_ES": "Ya no se le notificará esta semana.",
        "fr_FR": "Vous ne serez plus informé de cette semaine."
    },
    "Service has been successfully updated": {
        "es_ES": "El servicio se ha actualizado correctamente",
        "fr_FR": "Le service a été mis à jour avec succès"
    },
    "Please select weeks to report for.": {
        "es_ES": "Seleccione semanas para informar.",
        "fr_FR": "Veuillez sélectionner des semaines pour se présenter."
    },
    "You will not be reminded to report this week": {
        "es_ES": "No se le recordará que informes esta semana",
        "fr_FR": "Vous ne serez pas rappelé à signaler cette semaine"
    },
    "Select Action": {
        "es_ES": "Seleccione la acción",
        "fr_FR": "Sélectionner une action"
    },
    "Select Week": {
        "es_ES": "Seleccionar semana",
        "fr_FR": "Sélectionner la semaine"
    },
    "Select License Type": {
        "es_ES": "Seleccione Tipo de licencia",
        "fr_FR": "Sélectionner le type de licence"
    },
    "loading...": {
        "es_ES": "cargando...",
        "fr_FR": "chargement..."
    },
    "Songs reported successfuly": {
        "es_ES": "Canciones reportadas con éxito",
        "fr_FR": "Chansons rapportées"
    },
    "You have 1 message": {
        "es_ES": "Tiene 1 mensaje",
        "fr_FR": "Vous avez 1 message"
    },
    "New User": {
        "es_ES": "Nuevo Usuario",
        "fr_FR": "Nouvel utilisateur"
    },
    "You have {count} messages": {
        "es_ES": "Tiene {Count} mensajes",
        "fr_FR": "Vous avez {count} messages"
    },
    "License has been successfully upgraded to Recorded Audio": {
        "es_ES": "La licencia se ha actualizado correctamente a Grabación de Audio",
        "fr_FR": "La licence a été mise à niveau avec succès vers Enregistrement audio"
    },
    "Reporting 1 copy": {
        "es_ES": "Informes 1 copia",
        "fr_FR": "Rapport 1 copie"
    },
    "Reporting {copies} copies": {
        "es_ES": "Reportando {copies} copias",
        "fr_FR": "Déclaration de {copies} copies"
    },
    "Podcast confirmation": {
        "es_ES": "Confirmación de podcast",
        "fr_FR": "Confirmation de balado et diffusion en continu"
    },
    "Are you sure to add podcast to your license?": {
        "es_ES": "¿Seguro que agregará podcast a su licencia?",
        "fr_FR": "Êtes-vous sûr d'ajouter du balado et diffusion en continu à votre licence?"
    },
    "License has been successfully upgraded to Podcast": {
        "es_ES": "La licencia se ha actualizado con éxito al podcast",
        "fr_FR": "La licence a été mise à niveau avec succès en baladodiffusion"
    },
    "Are you sure to add recorded audio to your license?": {
        "es_ES": "¿Está seguro de que desea agregar una grabación de audio a su licencia?",
        "fr_FR": "Êtes-vous sûr de vouloir ajouter un enregistrement audio à votre licence ?"
    },
    "Recorded Audio confirmation": {
        "es_ES": "Confirmación de grabación de audio",
        "fr_FR": "Confirmation de l’enregistrement audio"
    },
    "Payment successful": {
        "es_ES": "Pago Exitoso",
        "fr_FR": "Paiement réussi"
    },
    "You don't have any new messages": {
        "es_ES": "No tiene nuevos mensajes.",
        "fr_FR": "Vous n’avez pas de nouveau message"
    },
    "Select Language": {
        "fr_FR": "Choisir la langue"
    },
    "No": {
        "fr_FR": "Non"
    }
}